import React from 'react';
import Icon from '../../../components/AppIcon';

const SessionTable = ({ sessions, onTerminate, currentUserId }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getSessionDuration = (loginTime) => {
    const start = new Date(loginTime);
    const now = new Date();
    const diffMs = now - start;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 60) return `${diffMins}m`;
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return `${hours}h ${mins}m`;
  };

  const getRiskLevel = (session) => {
    // Simple risk assessment based on session age
    const loginTime = new Date(session?.loginTime);
    const now = new Date();
    const hoursSinceLogin = (now - loginTime) / (1000 * 60 * 60);

    if (hoursSinceLogin > 12) return { level: 'High', color: 'text-red-600 bg-red-50' };
    if (hoursSinceLogin > 6) return { level: 'Medium', color: 'text-yellow-600 bg-yellow-50' };
    return { level: 'Low', color: 'text-green-600 bg-green-50' };
  };

  if (!sessions || sessions?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Users" className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600">No active sessions</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">User</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Login Time</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Duration</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Location</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">IP Address</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Risk</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Actions</th>
          </tr>
        </thead>
        <tbody>
          {sessions?.map((session, index) => {
            const risk = getRiskLevel(session);
            const isCurrentUser = session?.userId === currentUserId;
            
            return (
              <tr key={session?.id || index} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-4 px-4">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-xs font-semibold">
                        {session?.email?.charAt(0)?.toUpperCase()}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">
                        {session?.email}
                        {isCurrentUser && (
                          <span className="ml-2 text-xs text-blue-600 font-semibold">(You)</span>
                        )}
                      </p>
                      <p className="text-xs text-gray-500">ID: {session?.userId?.slice(0, 8)}...</p>
                    </div>
                  </div>
                </td>
                <td className="py-4 px-4">
                  <p className="text-sm text-gray-900">{formatDate(session?.loginTime)}</p>
                </td>
                <td className="py-4 px-4">
                  <p className="text-sm text-gray-900">{getSessionDuration(session?.loginTime)}</p>
                </td>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-2">
                    <Icon name="MapPin" className="w-4 h-4 text-gray-400" />
                    <p className="text-sm text-gray-900">{session?.location}</p>
                  </div>
                </td>
                <td className="py-4 px-4">
                  <p className="text-sm text-gray-900 font-mono">{session?.ipAddress}</p>
                </td>
                <td className="py-4 px-4">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${risk?.color}`}>
                    {risk?.level}
                  </span>
                </td>
                <td className="py-4 px-4 text-right">
                  <button
                    onClick={() => onTerminate(session?.id)}
                    disabled={isCurrentUser}
                    className="text-sm text-red-600 hover:text-red-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Terminate
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SessionTable;